/*

FILE: carousels.js
DESCRIPTION: Render carousels and handle functionality
AUTHOR(S): R.J. LaCount

*/

const Flickity = require('flickity-fade');
import Player from '@vimeo/player';
import { renderTimestamp } from './utils';

const initCarousels = (carousels) => {

	carousels.forEach((item) => {
		const parentSection = item.closest('section');
		const carouselArrows = parentSection.querySelector('.carousel-arrows');
		const dotsContainer = parentSection.querySelector('.carousel-dots');
		const customNavContainer = parentSection.querySelector('.carousel-custom-nav');
		const videoCarousel = item.classList.contains('video-carousel');

		const flkty = new Flickity(item, {
			prevNextButtons: false,
			pageDots: false,
			cellAlign: 'left',
			wrapAround: item.dataset.nowrap ? false : true,
			fade: item.dataset.fade,
			autoPlay: item.dataset.autoplay,
			draggable: (item.dataset.autoplay || item.dataset.nodrag) ? false : true,
			pauseAutoPlayOnHover: false
		});

		if (carouselArrows) {
			const prevButton = parentSection.querySelector('.carousel-arrow.prev');
			const nextButton = parentSection.querySelector('.carousel-arrow.next');
			prevButton.addEventListener('click', () => flkty.previous());
			nextButton.addEventListener('click', () => flkty.next());
		}

		if (dotsContainer) {
			const dots = Array.from(dotsContainer.children);

			dots.forEach((dot, i) => {
				dot.addEventListener('click', () => flkty.select(i));
			});

			flkty.on('select', () => {
				const previouslySelected = dotsContainer.querySelector('.is-selected');
				const currentlySelected = dots[flkty.selectedIndex];
				previouslySelected.classList.remove('is-selected');
				currentlySelected.classList.add('is-selected');
			});
		}

		if (customNavContainer) {
			const items = Array.from(customNavContainer.querySelectorAll('.carousel-custom-nav-item'));

			items.forEach((item, i) => {
				item.addEventListener('click', () => flkty.select(i));
			});

			flkty.on('select', () => {
				const previouslySelected = customNavContainer.querySelector('.is-selected');
				const currentlySelected = items[flkty.selectedIndex];
				previouslySelected.classList.remove('is-selected');
				currentlySelected.classList.add('is-selected');
			});
		}

		if (item.dataset.autoplay) {
			// Prevent interaction events from stopping autoplay
			flkty.on('staticClick', () => flkty.playPlayer());
			flkty.on('pointerUp', () => flkty.playPlayer());
			flkty.on('pointerMove', () => flkty.playPlayer());
			flkty.on('dragEnd', () => flkty.playPlayer());
		}

		if (videoCarousel) {

			flkty.slides.forEach(slide => {
				const el = slide.cells[0].element;
				const url = el.querySelector('[data-inline-video]').dataset.inlineVideo;
				const timestamp = el.querySelector('.timestamp');
				const videoContainer = el.querySelector('.video-container');

				slide.player = new Player(videoContainer, { url: url, autopause: true });

				slide.player.getDuration().then((duration) => {
					timestamp.innerHTML = renderTimestamp(duration);
				}).catch(function (error) {
					console.log('Error getting video duration.');
				});
			});

			flkty.on('staticClick', (event, pointer, cellElement, cellIndex) => {
				const slide = flkty.slides[cellIndex];

				flkty.cells.forEach(cell => {
					if (cell.element === cellElement && cell.element === flkty.selectedElement) {
						if (slide.player.isPlaying) {
							cellElement.classList.remove('play-video');
							slide.player.pause();
							slide.player.isPlaying = false;
						} else {
							cellElement.classList.add('play-video');
							slide.player.play();
							slide.player.isPlaying = true;
						}
					}
				});
			});

		}
	});
}

export { initCarousels };
